import { visitInfo } from '@/mocks/home';

const colLabel = 'fold-label text-[#8A8580] pb-4 border-b border-[rgba(23,21,21,0.16)]';

export default function VisitDetails() {
  const [street, ...rest] = visitInfo.address.split(', ');
  return (
    <section className="bg-[#EDE7DE] text-[#171515] py-16 md:py-24" aria-labelledby="details-title">
      <div className="fold-shell">
        <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-2 border-b border-[#171515] pb-5">
          <h2 id="details-title" className="fold-label">The bakery</h2>
          <p className="text-xs text-[#5d5853]">Sample details for preview — editable, not verified business information.</p>
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-12 gap-y-12 md:gap-x-8">
          <div className="md:col-span-12 lg:col-span-4 min-w-0">
            <p className={colLabel}>Find us</p>
            <address className="not-italic mt-5 fold-serif text-3xl md:text-[38px] leading-[1.1] tracking-[-0.02em]">
              {street}<br />
              <span className="text-[#5d5853]">{rest.join(', ')}</span>
            </address>
            <p className="mt-5 text-sm text-[#5d5853] max-w-[320px] leading-relaxed">Directions and a map will appear here once the real location is confirmed.</p>
          </div>

          <div className="md:col-span-6 lg:col-span-4 min-w-0">
            <p className={colLabel}>Opening hours</p>
            <dl>
              {visitInfo.hours.map((h) => (
                <div key={h.day} className="grid grid-cols-[minmax(0,1fr)_auto] gap-6 py-3.5 border-b border-[rgba(23,21,21,0.1)]">
                  <dt className="text-sm">{h.day}</dt>
                  <dd className="text-sm tabular-nums text-[#45403c] text-right">{h.time}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="md:col-span-6 lg:col-span-4 min-w-0">
            <p className={colLabel}>Contact &amp; pickup</p>
            <dl>
              <div className="grid grid-cols-[88px_minmax(0,1fr)] gap-4 py-3.5 border-b border-[rgba(23,21,21,0.1)]">
                <dt className="text-sm text-[#5d5853]">Phone</dt>
                <dd className="text-sm tabular-nums">{visitInfo.phone}</dd>
              </div>
              <div className="grid grid-cols-[88px_minmax(0,1fr)] gap-4 py-3.5 border-b border-[rgba(23,21,21,0.1)]">
                <dt className="text-sm text-[#5d5853]">Email</dt>
                <dd className="text-sm break-all">hello@fold.example</dd>
              </div>
              <div className="grid grid-cols-[88px_minmax(0,1fr)] gap-4 py-3.5 border-b border-[rgba(23,21,21,0.1)]">
                <dt className="text-sm text-[#5d5853]">Pickup</dt>
                <dd className="text-sm leading-relaxed text-[#45403c]">Request the day before. Collect at the counter during opening hours. Payment in store.</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}